export default "__VITE_ASSET__Dwzotcj6__"